import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from "react-helmet-async";
import {
  RouterProvider,
  createBrowserRouter
} from 'react-router-dom';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import App from './App';
import MainFrame from './Mainpages/MainFrame';
import Home from './Mainpages/Home';
import GrammarExercises from './Mainpages/Grammar-Exercises/grammar-pages/grammar-exercises';
import ToBePresent from './Mainpages/Grammar-Exercises/grammar-pages/to-be-present';
import ToBePast from './Mainpages/Grammar-Exercises/grammar-pages/to-be-past';
import SimplePresent from './Mainpages/Grammar-Exercises/grammar-pages/simple-present';
import PresentContinuous from './Mainpages/Grammar-Exercises/grammar-pages/present-continuous';
import SomeAny from './Mainpages/Grammar-Exercises/grammar-pages/some-any';
import Future from './Mainpages/Grammar-Exercises/grammar-pages/future';
import SimplePast from './Mainpages/Grammar-Exercises/grammar-pages/simple-past';
import FirstConditional from './Mainpages/Grammar-Exercises/grammar-pages/first-conditional';
import FirstCondProd from './Mainpages/Grammar-Exercises/grammar-pages/first-cond-prod';
import SecondConditional from './Mainpages/Grammar-Exercises/grammar-pages/second-conditional';
import ThirdConditional from './Mainpages/Grammar-Exercises/grammar-pages/third-conditional';
import PresentPerfect from './Mainpages/Grammar-Exercises/grammar-pages/present-perfect';
import PerfectPast from './Mainpages/Grammar-Exercises/grammar-pages/perfect-past';
import ThirdCondProd from './Mainpages/Grammar-Exercises/grammar-pages/third-cond-prod';
import IndirectSpeech from './Mainpages/Grammar-Exercises/grammar-pages/indirect-speech';
import ModalsObligation from './Mainpages/Grammar-Exercises/grammar-pages/modals-obligation';
import SenseVerbs from './Mainpages/Grammar-Exercises/grammar-pages/sense-verbs';
import EdIng from './Mainpages/Grammar-Exercises/grammar-pages/ed-ing';
import ReportedSpeech from './Mainpages/Grammar-Exercises/grammar-pages/reported-speech';
import PastContinuous from './Mainpages/Grammar-Exercises/grammar-pages/past-continuous';
import SecondCondProd from './Mainpages/Grammar-Exercises/grammar-pages/second-cond-prod';
import ModalsDeduction from './Mainpages/Grammar-Exercises/grammar-pages/modals-deduction';
import Passive from './Mainpages/Grammar-Exercises/grammar-pages/passive';
import Simpcont from './Mainpages/Grammar-Exercises/grammar-pages/simp-cont';
import Collocations from './Mainpages/Grammar-Exercises/grammar-pages/collocations';
import CollocationsList from './Mainpages/Grammar-Exercises/grammar-pages/collocations-list';
import WordForms from './Mainpages/Grammar-Exercises/grammar-pages/word-forms';
import LinkingWords from './Mainpages/Grammar-Exercises/grammar-pages/linking-words';
import DependentPrepositions from './Mainpages/Grammar-Exercises/grammar-pages/dependent-prepositions';
import Gerunds from './Mainpages/Grammar-Exercises/grammar-pages/gerunds';
import CauseEffect from './Mainpages/Grammar-Exercises/grammar-pages/cause-effect';
import Comparison from './Mainpages/Grammar-Exercises/grammar-pages/comparison';
import ComparisonA2 from './Mainpages/Grammar-Exercises/grammar-pages/comparison-a2';
import Relativeclauses from './Mainpages/Grammar-Exercises/grammar-pages/relative-clauses';
import Soenough from './Mainpages/Grammar-Exercises/grammar-pages/so-enough';
import Passivebeing from './Mainpages/Grammar-Exercises/grammar-pages/passive-being';
import PastHabits from './Mainpages/Grammar-Exercises/grammar-pages/past-habits';
import MixedCondProd from './Mainpages/Grammar-Exercises/grammar-pages/mixed-cond-prod';
import AdjAdv from './Mainpages/Grammar-Exercises/grammar-pages/adj-adv';
import ZeroConditional from './Mainpages/Grammar-Exercises/grammar-pages/zero-conditional';
import Infinitives from './Mainpages/Grammar-Exercises/grammar-pages/infinitives';
import Modals from './Mainpages/Grammar-Exercises/grammar-pages/modals';
import Punctuation from './Mainpages/Grammar-Exercises/grammar-pages/punctuation';
import PassiveGet from './Mainpages/Grammar-Exercises/grammar-pages/passive-get';
import PassiveReporting from './Mainpages/Grammar-Exercises/grammar-pages/passive-reporting';
import DescriptiveAdjectives from './Mainpages/Grammar-Exercises/grammar-pages/descriptive-adjectives';
import DeviceVerbs from './Mainpages/Grammar-Exercises/grammar-pages/device-verbs';
import GerundsInfinitives from './Mainpages/Grammar-Exercises/grammar-pages/gerunds-infinitives';
import Introductions from './Mainpages/Grammar-Exercises/grammar-pages/introductions';
import MoneyIdioms from './Mainpages/Grammar-Exercises/grammar-pages/money-idioms';
import ProvideVerb from './Mainpages/Grammar-Exercises/grammar-pages/provide-verb';
import Suggest from './Mainpages/Grammar-Exercises/grammar-pages/suggest';
import TenseReview from './Mainpages/Grammar-Exercises/grammar-pages/tense-review';
import ReadingExercises from './Mainpages/Reading-Exercises/reading-exercises';
import ParagraphHeadings from './Mainpages/Reading-Exercises/paragraph-headings';
import ReadingComprehension from './Mainpages/Reading-Exercises/reading-comprehension';
import SentenceGap from './Mainpages/Reading-Exercises/sentenceGap';
import FindGrammar from './Mainpages/Reading-Exercises/findGrammar';
import ReadingActivity from './Shared/Activities/ReadingActivity';
import SpeakingExercises from './Mainpages/Speaking-Exercises/speaking-exercises';
import PictureComparison from './Mainpages/Speaking-Exercises/picture-comparison';
import Speakingtopics from './Mainpages/Speaking-Exercises/speaking-topics';
import Videos from './Mainpages/Videos/videos';
import VideoActivity from './Shared/Activities/VideoActivity';
import WritingExercises from './Mainpages/Writing-Exercises/writing-exercises';
import Writing1 from './Mainpages/Writing-Exercises/Writing1';
import VocabularyExercises from './Mainpages/Vocabulary-Exercises/vocabulary-exercises';
import VocabularyList from './Mainpages/Vocabulary-Exercises/vocabulary-list';
import Flashcards from './Mainpages/Flashcards/Flashcard';
import QuizApp from './Mainpages/Quizzes/QuizApp';
import EnglishLevelTest from './Mainpages/Level-Test/level-test';
import TeachEnglish from './Mainpages/teach-english';
import Topics from './Mainpages/Topics/topics-pages/topics';
import Caffeine from './Mainpages/Topics/topics-pages/caffeine';
import Habits from './Mainpages/Topics/topics-pages/habits';
import Chatplatforms from './Mainpages/Topics/topics-pages/chatplatforms';
import Automation from './Mainpages/Topics/topics-pages/automation';
import Quality from './Mainpages/Topics/topics-pages/quality';
import Pets from './Mainpages/Topics/topics-pages/pets';
import Choice from './Mainpages/Topics/topics-pages/choice';
import Walking from './Mainpages/Topics/topics-pages/walking';
import People from './Mainpages/Topics/topics-pages/people';
import Food from './Mainpages/Topics/topics-pages/food';
import Tourism from './Mainpages/Topics/topics-pages/tourism';
import Neighbors from './Mainpages/Topics/topics-pages/neighbors';
import Sidejobs from './Mainpages/Topics/topics-pages/sidejobs';
import PerformanceReview from './Mainpages/Topics/topics-pages/performanceReview';
import Ethics from './Mainpages/Topics/topics-pages/ethics';
import Gossip from './Mainpages/Topics/topics-pages/gossip';
import Sustainability from './Mainpages/Topics/topics-pages/sustainability';
import Airtraffic from './Mainpages/Topics/topics-pages/airtraffic1';
import Unless from './Mainpages/Grammar-Exercises/grammar-pages/unless';
import Wish from './Mainpages/Grammar-Exercises/grammar-pages/wish';
import Problemsolving from './Mainpages/Topics/topics-pages/problemsolving';
import Medicine from './Mainpages/Topics/topics-pages/medicine';
import Persuading from './Mainpages/Topics/topics-pages/persuading';
import Sports from './Mainpages/Topics/topics-pages/sports';
import Weather from './Mainpages/Topics/topics-pages/weather';
import Introlesson from './Mainpages/Topics/topics-pages/introlesson';
import Education from './Mainpages/Topics/topics-pages/education';
import Branding from './Mainpages/Topics/topics-pages/branding';
import FastFood from './Mainpages/Topics/topics-pages/fastfood';
import WorkFuture from './Mainpages/Topics/topics-pages/workfuture';
import Meetings from './Mainpages/Topics/topics-pages/meetings';
import Money from './Mainpages/Topics/topics-pages/money';
import Cellphones from './Mainpages/Topics/topics-pages/smartphones';
import Language from './Mainpages/Topics/topics-pages/language';
import Companypolicy from './Mainpages/Topics/topics-pages/companypolicy';
import Writing from './Mainpages/Topics/topics-pages/writing';
import StreamingServices from './Mainpages/Topics/topics-pages/streamingServices';
import BucketList from './Mainpages/Topics/topics-pages/bucketlist';
import Parenting from './Mainpages/Topics/topics-pages/parenting';
import Corruption from './Mainpages/Topics/topics-pages/corruption';
import Value from './Mainpages/Topics/topics-pages/value';
import Elections from './Mainpages/Topics/topics-pages/elections';
import Music from './Mainpages/Topics/topics-pages/music';
import AirtrafficFuture from './Mainpages/Topics/topics-pages/airtrafficfuture';
import Gambling from './Mainpages/Topics/topics-pages/gambling';
import Sleep from './Mainpages/Topics/topics-pages/sleep';
import Tipping from './Mainpages/Topics/topics-pages/tipping';
import Holidays from './Mainpages/Topics/topics-pages/holidays';
import GiftGiving from './Mainpages/Topics/topics-pages/giftgiving';
import Belief from './Mainpages/Topics/topics-pages/belief';
import Usedto from './Mainpages/Grammar-Exercises/grammar-pages/used-to';
import NewYear2026 from './Mainpages/Topics/topics-pages/newyear2026';
import TeamBuilding from './Mainpages/Topics/topics-pages/teambuilding';
import Musicmemory from './Mainpages/Topics/topics-pages/musicmemory';
import AirTrafficSnow from './Mainpages/Topics/topics-pages/airtrafficsnow';
import CellPhonePlane from './Mainpages/Topics/topics-pages/cellphoneplane';
import SalesDriving from './Mainpages/Topics/topics-pages/salesdriving';
import Conspiracy from './Mainpages/Topics/topics-pages/conspiracy';
import Businessscandals from './Mainpages/Topics/topics-pages/businessscandals';
import Whatif from './Mainpages/Topics/topics-pages/whatif';
import Alcohol from './Mainpages/Topics/topics-pages/alcohol';
import Goodmanager from './Mainpages/Topics/topics-pages/goodmanager';
import Spirituality from './Mainpages/Topics/topics-pages/spirituality';
import Procrastination from './Mainpages/Topics/topics-pages/procrastination';
import SolvingProblemDev from './Mainpages/Topics/topics-pages/solvingproblemdev';
import Cars from './Mainpages/Topics/topics-pages/cars';
import Personality from './Mainpages/Topics/topics-pages/personality';
import Ailaw from './Mainpages/Topics/topics-pages/ailaw';
import Endownership from './Mainpages/Topics/topics-pages/endownership';
import Foodculture from './Mainpages/Topics/topics-pages/foodculture';
import Nospend from './Mainpages/Topics/topics-pages/nospend';
import Memory from './Mainpages/Topics/topics-pages/memory';
import Entertainmentcost from './Mainpages/Topics/topics-pages/entertainmentcost';
import Talenthardwork from './Mainpages/Topics/topics-pages/talenthardwork';
import Howthingswork from './Mainpages/Topics/topics-pages/howthingswork';
import Socialetiquette from './Mainpages/Topics/topics-pages/socialetiquette';
import Beingbusy from './Mainpages/Topics/topics-pages/beingbusy';
import Cashlesssociety from './Mainpages/Topics/topics-pages/cashlesssociety';
import Historyofnutrition from './Mainpages/Topics/topics-pages/historyofnutrition';
import Hobbies from './Mainpages/Topics/topics-pages/hobbies';
import PrivacyPolicy from './Mainpages/PrivacyPolicy';
import TermsOfService from './Mainpages/TermsOfService';
import Contact from './Mainpages/Contact';


const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <MainFrame />,
        children: [
          {
            index: true, 
            element: <Home />,
          },
          {
            path: 'teach-english',
            element: <TeachEnglish />,
          },
          {
            path: 'privacy-policy',
            element: <PrivacyPolicy />,
          },
          {
            path: 'terms-of-service',
            element: <TermsOfService />,
          },
          {
            path: 'contact',
            element: <Contact />,
          },
          {
            path: 'level-test/level-test',
            element: <EnglishLevelTest />,
          },
          {
            path: 'lesson-plans',
            element: <Topics />,
          },
          {
            path: 'lesson-plans/cashlesssociety',
            element: <Cashlesssociety />,
          },
          {
            path: 'lesson-plans/beingbusy',
            element: <Beingbusy />,
          },
          {
            path: 'lesson-plans/socialetiquette',
            element: <Socialetiquette />,
          },
          {
            path: 'lesson-plans/talenthardwork',
            element: <Talenthardwork />,
          },
          {
            path: 'lesson-plans/howthingswork',
            element: <Howthingswork />,
          },
          {
            path: 'lesson-plans/entertainmentcost',
            element: <Entertainmentcost />,
          },
          {
            path: 'lesson-plans/memory',
            element: <Memory />,
          },
          {
            path: 'lesson-plans/nospend',
            element: <Nospend />,
          },
          {
            path: 'lesson-plans/foodculture',
            element: <Foodculture />,
          },
          {
            path: 'lesson-plans/endownership',
            element: <Endownership />,
          },
          {
            path: 'lesson-plans/ailaw',
            element: <Ailaw />,
          },
          {
            path: 'lesson-plans/personality',
            element: <Personality />,
          },
          {
            path: 'lesson-plans/cars',
            element: <Cars />,
          },
          {
            path: 'lesson-plans/solvingproblemdev',
            element: <SolvingProblemDev />,
          },
          {
            path: 'lesson-plans/procrastination',
            element: <Procrastination />,
          },
          {
            path: 'lesson-plans/spirituality',
            element: <Spirituality />,
          },
          {
            path: 'lesson-plans/goodmanager',
            element: <Goodmanager />,
          },
          {
            path: 'lesson-plans/alcohol',
            element: <Alcohol />,
          },
          {
            path: 'lesson-plans/whatif',
            element: <Whatif />,
          },
          {
            path: 'lesson-plans/businessscandals',
            element: <Businessscandals />,
          },
          {
            path: 'lesson-plans/musicmemory',
            element: <Musicmemory />,
          },
          {
            path: 'lesson-plans/airtrafficsnow',
            element: <AirTrafficSnow />,
          },
          {
            path: 'lesson-plans/cellphoneplane',
            element: <CellPhonePlane />,
          },
          {
            path: 'lesson-plans/language',
            element: <Language />,
          },
          {
            path: 'lesson-plans/teambuilding',
          element: <TeamBuilding />,
          },
          {
            path: 'lesson-plans/newyear2026',
            element: <NewYear2026 />,
          },
          {
            path: 'lesson-plans/branding',
            element: <Branding />,
          },
          {
            path: 'lesson-plans/smartphones',
            element: <Cellphones />,
          },
          {
            path: 'lesson-plans/money',
            element: <Money />,
          },
          {
            path: 'lesson-plans/meetings',
          element: <Meetings />,
          },
          {
            path: 'lesson-plans/workfuture',
          element: <WorkFuture />,
          },
          {
            path: 'lesson-plans/historyofnutrition',
          element: <Historyofnutrition />,
          },
          {
            path: 'lesson-plans/fastfood',
            element: <FastFood />,
          },
          {
            path: 'lesson-plans/caffeine',
            element: <Caffeine />,
          },
          {
            path: 'lesson-plans/habits',
            element: <Habits />,
          },
          {
            path: 'lesson-plans/chatplatforms',
            element: <Chatplatforms />,
          },
          {
            path: 'lesson-plans/automation',
            element: <Automation />,
          },
          {
            path: 'lesson-plans/quality',
            element: <Quality />,
          },
          {
            path: 'lesson-plans/choice',
            element: <Choice />,
          },
          {
            path: 'lesson-plans/pets',
            element: <Pets />,
          },
          {
            path: 'lesson-plans/walking',
            element: <Walking />,
          },
          {
            path: 'lesson-plans/people',
            element: <People />,
          },
          {
            path: 'lesson-plans/neighbors',
            element: <Neighbors />,
          },
          {
            path: 'lesson-plans/food',
            element: <Food />,
          },
          {
            path: 'lesson-plans/tourism',
            element: <Tourism />,
          },
          {
            path: 'lesson-plans/performancereview',
            element: <PerformanceReview />,
          },
          {
            path: 'lesson-plans/ethics',
            element: <Ethics />,
          },
          {
            path: 'lesson-plans/gossip',
            element: <Gossip />,
          },          
          {
            path: 'lesson-plans/sustainability',
            element: <Sustainability />,
          },          
          {
            path: 'lesson-plans/problemsolving',
            element: <Problemsolving />,
          },          
          {
            path: 'lesson-plans/medicine',
            element: <Medicine />,
          },          
          {
            path: 'lesson-plans/sports',
            element: <Sports />,
          },          
          {
            path: 'lesson-plans/persuading',
            element: <Persuading />,
          },          
          {
            path: 'lesson-plans/weather',
            element: <Weather />,
          },          
          {
            path: 'lesson-plans/education',
            element: <Education />,
          },          
          {
            path: 'lesson-plans/introlesson',
            element: <Introlesson />,
          },
          {
            path: 'lesson-plans/airtraffic',
            element: <Airtraffic />,
          },
          {
            path: 'lesson-plans/airtrafficfuture',
            element: <AirtrafficFuture />,
          },
          {
            path: 'lesson-plans/companypolicy',
            element: <Companypolicy />,
          },
          {
            path: 'lesson-plans/sidejobs',
            element: <Sidejobs />,
          },
          { 
            path: 'lesson-plans/streamingservices',
            element: <StreamingServices />,
          },
          { 
            path: 'lesson-plans/parenting',
            element: <Parenting />,
          },
          { 
            path: 'lesson-plans/bucketlist',
            element: <BucketList />,
          },
          { 
            path: 'lesson-plans/corruption',
            element: <Corruption />,
          },
          { 
            path: 'lesson-plans/value',
            element: <Value />,
          },
          { 
            path: 'lesson-plans/elections',
            element: <Elections />,
          },
          { 
            path: 'lesson-plans/music',
            element: <Music />,
          },
          { 
            path: 'lesson-plans/writing',
            element: <Writing />,
          },
          { 
            path: 'lesson-plans/gambling',
            element: <Gambling />,
          },
          { 
            path: 'lesson-plans/sleep',
            element: <Sleep />,
          },
          { 
            path: 'lesson-plans/tipping',
            element: <Tipping />,
          },
          { 
            path: 'lesson-plans/holidays',
            element: <Holidays />,
          },
          { 
            path: 'lesson-plans/giftgiving',
            element: <GiftGiving />,
          },
          { 
            path: 'lesson-plans/belief',
            element: <Belief />,
          },
          { 
            path: 'lesson-plans/salesdriving',
            element: <SalesDriving />,
          },
          { 
            path: 'lesson-plans/conspiracy',
            element: <Conspiracy />,
          },
          {
            path: 'lesson-plans/hobbies',
            element: <Hobbies />,
          },
          {
            path: 'grammar-exercises',
            element: <GrammarExercises />,
          },
          {
            path: 'grammar-exercises/to-be-present',
            element: <ToBePresent />,
          },
          {
            path: 'grammar-exercises/to-be-past',
            element: <ToBePast />,
          },
          {
            path: 'grammar-exercises/simple-present',
            element: <SimplePresent />,
          },
          {
            path: 'grammar-exercises/present-continuous',
            element: <PresentContinuous />,
          },
          {
            path: 'grammar-exercises/some-any',
            element: <SomeAny />,
          },          
          {
            path: 'grammar-exercises/simpcont',
            element: <Simpcont />,
          },
          {
            path: 'grammar-exercises/future',
            element: <Future />,
          },
          {
            path: 'grammar-exercises/simple-past',
            element: <SimplePast />,
          },
          {
            path: 'grammar-exercises/past-continuous',
            element: <PastContinuous />,
          },
          {
            path: 'grammar-exercises/present-perfect',
            element: <PresentPerfect />,
          },
          {
            path: 'grammar-exercises/perfect-past',
            element: <PerfectPast />,
          },
          {
            path: 'grammar-exercises/first-conditional',
            element: <FirstConditional />,
          },
          {
            path: 'grammar-exercises/first-cond-prod',
            element: <FirstCondProd />,
          },
          {
            path: 'grammar-exercises/second-conditional',
            element: <SecondConditional />,
          },
          {
            path: 'grammar-exercises/second-cond-prod',
            element: <SecondCondProd />,
          },
          {
            path: 'grammar-exercises/third-conditional',
            element: <ThirdConditional />,
          },
          {
            path: 'grammar-exercises/third-cond-prod',
            element: <ThirdCondProd />,
          },
          {
            path: 'grammar-exercises/mixed-cond-prod',
            element: <MixedCondProd />,
          },
          {
            path: 'grammar-exercises/indirect-speech',
            element: <IndirectSpeech />,
          },
          {
            path: 'grammar-exercises/passive',
            element: <Passive />,
          },
          {
            path: 'grammar-exercises/pasthabits',
            element: <PastHabits />,
          },
          {
            path: 'grammar-exercises/passivebeing',
            element: <Passivebeing />,
          },
          {
            path: 'grammar-exercises/modals-obligation',
            element: <ModalsObligation />,
          },
          {
            path: 'grammar-exercises/modals-deduction',
            element: <ModalsDeduction />,
          },
          {
            path: 'grammar-exercises/sense-verbs',
            element: <SenseVerbs />,
          },          
          {
            path: 'grammar-exercises/ed-ing',
            element: <EdIng />,
          },          
          {
            path: 'grammar-exercises/reported-speech',
            element: <ReportedSpeech />,
          },          
          {
            path: 'grammar-exercises/gerunds',
            element: <Gerunds />,
          },          
          {
            path: 'grammar-exercises/infinitives',
            element: <Infinitives />,
          },
          {
            path: 'grammar-exercises/modals',
            element: <Modals />,
          },             
          {
            path: 'grammar-exercises/causeeffect',
            element: <CauseEffect />,
          },         
          {
            path: 'grammar-exercises/comparison',
            element: <Comparison />,
          }, 
          {
            path: 'grammar-exercises/comparison-a2',
            element: <ComparisonA2 />,
          }, 
          {
            path: 'grammar-exercises/relativeclauses',
            element: <Relativeclauses />,
          },         
          {
            path: 'grammar-exercises/soenough',
            element: <Soenough />,
          },         
          {
            path: 'grammar-exercises/unless',
            element: <Unless />,
          },         
          {
            path: 'grammar-exercises/wish',
            element: <Wish />,
          },         
          {
            path: 'grammar-exercises/adjadv',
            element: <AdjAdv />,
          },
          {
            path: 'grammar-exercises/zero-conditional',
            element: <ZeroConditional />,
          },
          {
            path: 'grammar-exercises/collocations',
            element: <Collocations />,
          },
          {
            path: 'grammar-exercises/collocations-list',
            element: <CollocationsList />,
          },
          {
            path: 'grammar-exercises/dependent-prepositions',
            element: <DependentPrepositions />,
          },
          {
            path: 'grammar-exercises/word-forms',
            element: <WordForms />,
          },
          {
            path: 'grammar-exercises/linking-words',
            element: <LinkingWords />,
          },
          {
            path: 'grammar-exercises/usedto',
            element: <Usedto />,
          },
          {
            path: 'grammar-exercises/punctuation',
            element: <Punctuation />,
          },
          {
            path: 'grammar-exercises/passive-get',
            element: <PassiveGet />,
          },
          {
            path: 'grammar-exercises/passive-reporting',
            element: <PassiveReporting />,
          },
          {
            path: 'grammar-exercises/descriptive-adjectives',
            element: <DescriptiveAdjectives />,
          },
          {
            path: 'grammar-exercises/device-verbs',
            element: <DeviceVerbs />,
          },
          {
            path: 'grammar-exercises/gerunds-infinitives',
            element: <GerundsInfinitives />,
          },
          {
            path: 'grammar-exercises/introductions',
            element: <Introductions />,
          },
          {
            path: 'grammar-exercises/money-idioms',
            element: <MoneyIdioms />,
          },
          {
            path: 'grammar-exercises/provide-verb',
            element: <ProvideVerb />,
          },
          {
            path: 'grammar-exercises/suggest',
            element: <Suggest />,
          },
          {
            path: 'grammar-exercises/tense-review',
            element: <TenseReview />,
          },
          {
            path: 'reading-exercises',
            element: <ReadingExercises />,
          },
          {
            path: '/reading/:id',
            element: <ReadingActivity />,
          },
          {
            path: '/reading-exercises/reading-comprehension',
            element: <ReadingComprehension />,
          },
          {
            path: 'reading-exercises/paragraph-headings',
            element: <ParagraphHeadings />,
          },
          {
            path: 'reading-exercises/sentenceGap',
            element: <SentenceGap />,
          },
          {
            path: 'reading-exercises/findGrammar',
            element: <FindGrammar />,
          },
          {
            path: 'writing-exercises',
            element: <WritingExercises />,
          },
          {
            path: 'writing-exercises/writing1',
            element: <Writing1 />,
          },
          {
            path: '/videos',
            element: <Videos />,
          },
          {
            path: '/videos/:id',
            element: <VideoActivity />,
          },
          {
            path: 'vocabulary-exercises',
            element: <VocabularyExercises />,
          },
          {
            path: 'vocabulary-exercises/list',
            element: <VocabularyList />,
          },
          {
            path: 'flashcards',
            element: <Flashcards />,
          },
          {
            path: 'quizzes',
            element: <QuizApp />,
          },
          {
            path: 'speaking-exercises',
            element: <SpeakingExercises />,
          },
          {
            path: 'speaking-exercises/speaking-topics',
            element: <Speakingtopics />,
          },
          {
            path: 'speaking-exercises/picture-comparison',
            element: <PictureComparison />,
          },
        ],
      },
    ]
  }
]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <HelmetProvider>
    <RouterProvider router={router} />
  </HelmetProvider>
);


